import { useSyncExternalStore } from "react";

// Official uploads only: « Envoyer à l'atelier » for the next upload(s) of this screen (reset once sent).
let current = false;
const subs = new Set();

export const atelierChoice = () => (current ? { atelier: true } : {});

export const setAtelier = (on) => {
  current = on;
  subs.forEach((f) => f());
};

export const resetAtelier = () => setAtelier(false);

export const useAtelier = () =>
  useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => current);
